import { forwardRef } from "react";
function SvgArrowLineLeft({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={173}
      height={72}
      viewBox="0 0 173 72"
      preserveAspectRatio="none"
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        d="M9.546 13.5c0-7.456 6.044-13.5 13.5-13.5h148a1.5 1.5 0 0 1 0 3h-148c-5.8 0-10.5 4.701-10.5 10.5v53.379l6.985-6.985a1.5 1.5 0 1 1 2.121 2.12l-9.546 9.547a1.5 1.5 0 0 1-2.12 0L.438 62.015a1.5 1.5 0 1 1 2.121-2.121l6.986 6.985V13.5Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgArrowLineLeft);
export default ForwardRef;
